import { AllDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

export default class AllXResultsSelectionItem extends AllDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.competitors-table-actions-panel.options.contacts.all.selected",
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
